export const pSalesStatsRequest = ({ end, start }) => {
  return {
    end: end.format('YYYY-MM-DDTHH:mm:ssZ'),
    start: start.format('YYYY-MM-DDTHH:mm:ssZ'),
  }
}
